import { connect } from 'react-redux';
import Dictionary from 'dictionary';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import WorksComponent from './WorksComponent';

const mapStateToProps = (state, ownProps) => {
	const { taxonomy, term } = ownProps.match.params;
	const taxonomy_singular = Dictionary.get([taxonomy, 'singular'], null);
	const taxonomy_title = taxonomy_singular ? taxonomy_singular : Dictionary.get(taxonomy);

	const entry = get( state.fetcher, ['archives', taxonomy, term] );
	const status = entry ? entry.status : null;
	const title = get( entry, ['data', 'title'], startCase(term) );
	const items = get( entry, ['data', 'items'], [] );

	return {
		loaded: (status === 'success' || status === 'error'),
		items: (items.length > 0)? items : null,
		breadcrumb: [{title: taxonomy_title }, {title: title }]
	}
}

export default connect(mapStateToProps)(WorksComponent);


// WEBPACK FOOTER //
// ./src/components/Pages/Works/Term.jsx